<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.pending_review_funds_voucher") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col
                .d-inline-block
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.refresh') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="$options.refreshOn" @change="toggleRefresh()")
                        span.custom-switch-indicator
                    b-input-group-text(slot="append")
                      b-input(v-model="refreshInterval" type="range" min="1" max="5")
                    b-input-group-text(slot="append")
                      span {{ refreshInterval }} s
                .d-inline-block.align-top.ml-2
                  b-input-group(size="sm").mb-1
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.alert') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type="checkbox" v-model="alert")
                        span.custom-switch-indicator

              .form-group.col-12
                .row
                  .col-4
                    .form-group
                      b-input-group(size="sm")
                        b-form-select.col-4(v-model="searchType" size="sm" @input="resetInput()")
                          option(value="operator") {{ $t('ui.operator') }}
                          option(value="ticket") {{ $t('ui.ticket') }}
                        template(v-if="['operator'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="operatorID" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                        template(v-if="['ticket'].includes(searchType)")
                          DebounceInput(autofocus type="text" v-model="ticketId" :placeholder="$t('message.search_by_' + searchType)" @enter="getTicketList()" size="sm")
                  .col-6
                    template(v-if="['operator'].includes(searchType)")
                      template(v-if="operatorID != ''")
                        .form-group.col-6
                          b-input-group(size="sm")
                            b-input-group-text(slot="prepend")
                              i.fa.fa-search
                            DebounceInput(autofocus type="text" v-model="memberID" :placeholder="$t('ui.member')" size="sm")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getTicketList()"
                  variant="primary"
                  size="sm"
                )

          .card-body
            .row
              .col-12
                ul#tickettab.nav.nav-tabs(role='tablist')
                  li.nav-item
                    a#deposit-tab.nav-link.active(data-toggle='tab' href='#deposit-content' role='tab' aria-controls='deposit' aria-selected='false')
                      span {{ $t("ui.deposit") }}
                      b-badge.ticket-total-badge(variant="danger" size="sm").ml-1 {{ depTotalRow }}

                #tickettabcontent.tab-content.tab-bordered
                  #deposit-content.tab-pane.active.show(role='tabpanel' aria-labelledby='deposit-tab')
                    .row
                      .col-10.mb-1
                        b-pagination.float-left(
                          size="sm"
                          hide-ellipsis
                          :total-rows="depTotalRow"
                          :per-page="getPageSize"
                          v-model="currentDepPage"
                          @input="changedDepPage($event)").mb-1
                      .col-2.mb-1
                        b-input-group(:prepend="$t('ui.page_size')" size="sm")
                          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedDepPageSize" size="sm")
                      .col-12
                        .clusterize-scroll.table-responsive
                          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                            thead.thead-light
                              tr
                                th.text-center(width="3%")
                                  span #
                                th(width="5%")
                                  span(:title="$t('ui.id')") {{ $t('ui.id') }}
                                th(width="5%")
                                  span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                                th(width="8%")
                                  span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                th(width="5%")
                                  span(:title="$tc('ui.banks', 1)") {{ $tc('ui.banks', 1) }}
                                th(width="8%")
                                  span(:title="$t('ui.bank_acc_no')") {{ $t('ui.bank_acc_no') }}
                                th(width="8%")
                                  span(:title="$t('ui.bank_acc_holder')") {{ $t('ui.bank_acc_holder') }}
                                th(width="5%")
                                  span(:title="$t('ui.mode')") {{ $t('ui.mode') }}
                                th.text-right(width="8%")
                                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                                th(width="6%")
                                  span(:title="$t('ui.promo')") {{ $t("ui.promo") }}
                                th.text-right(width="6%")
                                  span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                                th(width="6%")
                                  span(:title="$t('ui.upline')") {{ $t("ui.upline") }}
                                th(width="6%")
                                  span(:title="$t('ui.vip')") {{ $t("ui.vip") }}
                                th.text-center(width="11%")
                                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                                th.text-right(width="10%")
                                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                            tbody.clusterize-content
                              tr(v-if="depositList.length == 0")
                                td(:colspan="15").text-center
                                  span {{ $t('message.no_data_available') }}
                              tr(v-for="(item, index) in depositList" :class="$helpers.rowClassTicket(item, 'deposit')")
                                td.text-center
                                  span(:title="((currentDepPage - 1) * getPageSize + index + 1)") {{ ((currentDepPage - 1) * getPageSize + index + 1) }}
                                td
                                  span.d-block(:title="item.id") {{ item.id }}
                                  span.small.text-info.d-block(:title="getRefNo(item.target_bank_id, item.id, item.prefix_vch, item.prefix_delimiter)") {{ getRefNo(item.target_bank_id, item.id, item.prefix_vch, item.prefix_delimiter) }}
                                td
                                  span(:title="item.parent_id") {{ item.parent_id }}
                                td
                                  span.font-weight-bold(:title="item.member_id")
                                    b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.member_id }}
                                td
                                  span(:title="item.target_bank_id") {{ item.target_bank_id }}
                                td
                                  span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                                td
                                  span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                                td
                                  span(:title="item.deposit_method") {{ item.deposit_method }}
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                                td
                                  span(:title="item.promotion_id") {{ item.promotion_id }}
                                td.text-right
                                  span.font-weight-bold.d-block(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
                                td
                                  span(:title="item.referrer_id") {{ item.referrer_id }}
                                td
                                  span(:title="item.vip_name") {{ item.vip_name }}
                                td.text-center
                                  template(v-if="isEditAccess")
                                    span(v-if="item.status.trim().toUpperCase() != 'PENDING'")
                                      a.fa.fa-search.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="getTicketVoucherDetail(item, $event)" :title="$t('ui.view')")
                                    span.ml-1(v-if="item.attachment_path")
                                      a.fa.fa-paperclip.btn.btn-ssm.btn-icon.btn-warning(href="javascript:void(0)" @click="openAttachment(item)" :title="$t('ui.attachment')")
                                    span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                      a.fa.fa-check.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="approveTicketVoucher(item, $event)" :title="$t('ui.approve')")
                                    span.ml-1(v-if="item.status.trim().toUpperCase() == 'PENDING'")
                                      a.fa.fa-ban.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="rejectTicketVoucher(item, $event)" :title="$t('ui.reject')")
                                td.text-right
                                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    ticketvoucherdetail(ref="ticketvoucherdetail" :ticketId="selectedTicketId" @failed="handleFailed")
    approveticketvoucher(ref="approveticketvoucher" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    rejectticketvoucher(ref="rejectticketvoucher" :ticketId="selectedTicketId" @clicked="afterEditTicket" @failed="handleFailed")
    manualapproveticketvoucher(ref="manualapproveticketvoucher" :ticketId="selectedTicketId" :parentId="selectedParentId" :memberId="selectedMemberId" @clicked="afterEditTicket" @failed="handleFailed")
    exchangecurrencyticketvoucherdetail(ref="exchangecurrencyticketvoucherdetail" :ticketId="selectedTicketId" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ticketvoucherdetail from "@/components/ticketvoucher/ticketVoucherDetail.vue";
import approveticketvoucher from "@/components/ticketvoucher/approveTicketVoucher.vue";
import rejectticketvoucher from "@/components/ticketvoucher/rejectTicketVoucher.vue";
import manualapproveticketvoucher from "@/components/ticketvoucher/manualApproveTicketVoucher.vue";
import exchangecurrencyticketvoucherdetail from "@/components/ticketvoucher/exchangeCurrencyTicketVoucherDetail.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ticketvoucherdetail,
    approveticketvoucher,
    rejectticketvoucher,
    manualapproveticketvoucher,
    exchangecurrencyticketvoucherdetail
  },
  data: () => ({
    loading: false,
    depositList: [],
    currentDepPage: 1,
    depTotalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    requestType: null,
    ticketTimer: null,
    refreshInterval: 5,
    refreshChange: "",
    selectedTicketId: null,
    selectedTicket: null,
    selectedParentId: null,
    selectedMemberId: null,
    al: null,
    search: '',
    editSelectedMember: null,
    step: 0,
    ticketId: "",
    searchType: "ticket",
    operatorID: "",
    memberID: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    alert:
    {
      get() {
        return this.$store.getters.alertOn;
      },
      set(value) {
        this.changedAlertOn(value);
      }
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_pendingticket");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  created: function() {
    this.$options.refreshOn = false;
  },
  mounted: function() {
    if (this.$store.getters.pendingTicket.tab != null && this.$store.getters.pendingTicket.tab != '') {
      this.step = this.$store.getters.pendingTicket.tab;
    }
    this.getTicketList();
  },
  destroyed: function() {
    this.$store.dispatch("user/setSelectedMemberID", null);

    if (this.ticketTimer) {
      clearTimeout(this.ticketTimer);
    } 
    var json = {
      tab: null
    };
    this.$store.dispatch("user/setPendingTicketParam", json);
  },
  methods: {
    showLabel(item, mode) {
      if(mode == 'label') {
        return this.$t('ui.ignore_risk') + ': ' + item.d + '\n' + this.$t('ui.permitted_amount') + ': ' + item.e
      }

      if(mode == 'taken') {
        return item.taken_by + '\n' + item.taken_date
      }
      return null
    },
    checkTaker(e) {
      // Get the original taken_by value (before v-model converts it to boolean)
      // If taken_by is a boolean, it means v-model has modified it, so we need to check taken_by_original
      // Otherwise, use taken_by directly (it's still the original string value from API)
      let takenBy;
      if (typeof e.taken_by === 'boolean') {
        // v-model has converted it to boolean, use original value if available
        takenBy = (e.taken_by_original !== undefined && e.taken_by_original !== null) 
          ? e.taken_by_original 
          : null;
      } else {
        // Still the original value from API (string or null)
        takenBy = e.taken_by;
      }
      
      // Enable (return false) when both taken_by and taken_date are null or empty
      if (!takenBy && !e.taken_date) return false;

      // Enable (return false) when loginId matches taken_by
      // Disable (return true) when loginId does not match taken_by
      return String(this.loginId) !== String(takenBy);
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.ticket_taken_confirm", { name: item.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.taken_by;
            item.taken_by = !item.taken_by;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = status ? config.ticketTakenMarkUrl() : config.ticketTakenUnmarkUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: item.id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getTicketList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getTicketList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTextColor(backgroundColor) {
      if (!backgroundColor) return '#000000'; // Default to black if no color provided
      // Convert hex color to RGB
      const rgb = backgroundColor.replace('#', '').match(/.{1,2}/g).map((hex) => parseInt(hex, 16));
      // Calculate relative luminance
      const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
      return luminance > 0.5 ? '#000000' : '#ffffff'; // Black for light backgrounds, white for dark
    },
    resetInput() {
      this.operatorID = "";
      this.memberID = "";
      this.ticketId = "";
    },
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
    changedAlertOn: function(eventStatus) {
      this.$store.dispatch("user/setAlertOn", eventStatus);
    },
    getTicketList() {
      this.getDepositList(true);
    },
    openAttachment(obj) {
      this.$store.dispatch("user/setAttachmentPath", obj.attachment_path);
      let routeData = this.$router.resolve({path: '/attachment'});
      window.open(routeData.href, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=250,width=1500,height=800");
    },
    getDepositList: function(isSearch) {
      let url = config.ticketVoucherListPendingUrl();

      if (isSearch) this.currentDepPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        page_number: this.currentDepPage,
        page_size: this.getPageSize
      };

      if(this.searchType == 'operator') {
        json.operator_id = this.operatorID
        json.member_id = this.memberID
      } else {
        json.ticket_id = this.ticketId ? this.$helpers.getTicketId(this.ticketId) : null
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositList = response.data.dt;
                this.depTotalRow = this.depositList.length > 0 ? this.depositList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTicketVoucherDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.ticketvoucherdetail.$refs.ticketVoucherDetail.show();
    },
    getExchangeCurrencyTicketVoucherDetail: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.exchangecurrencyticketvoucherdetail.$refs.exchangeCurrencyTicketVoucherDetail.show();
    },
    afterEditTicket: function(type, afterBalance) {
      this.getTicketList();

      if (type == 1) {
        this.$swal({
          title: this.$t("ui.combine.edit_ticket"),
          html:
            "<div>" +
            this.$t("ui.after_balance") +
            ": <strong>" +
            this.$n(afterBalance, 'currency') +
            "</strong></div>",
          type: "success",
          confirmButtonText: this.$t("ui.ok"),
          allowOutsideClick: false
        }).then(isConfirm => {
          if (isConfirm.value) {

          }
        });
      } else
        this.$helpers.showDialog(this.$t("ui.combine.edit_ticket"), this.$t("message.success"), "success");
    },
    approveTicketVoucher: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.approveticketvoucher.$refs.approveTicketVoucher.show();
    },
    rejectTicketVoucher: function(e) {
      this.selectedTicketId = e.id;
      this.$refs.rejectticketvoucher.$refs.rejectTicketVoucher.show();
    },
    onInfo(e) {
      this.$store.dispatch("user/setSelectedOperatorID", e.parent_id);
      this.$store.dispatch("user/setSelectedMemberID", e.member_id);
      window.open(window.location.origin + "/account/settings", '_blank');
    },
    manualApproveTicketVoucher: function(e) {
      this.selectedTicketId = e.id;
      this.selectedParentId = e.parent_id;
      this.selectedMemberId = e.member_id;
      this.$refs.manualapproveticketvoucher.$refs.manualApproveTicketVoucher.show();
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    startRefreshTimer: function() {
      if (this.ticketTimer) {
        clearTimeout(this.ticketTimer);
      }
      if (this.$options.refreshOn) {
        this.getTicketList();
        this.ticketTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    changedDepPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentDepPage = 1;
      this.getDepositList(true);
    },
    changedDepPage: function(pageNo) {
      this.currentDepPage = pageNo;
      this.getDepositList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>